import Blog from '../views/Blog.vue';
import BlogGeneral from '../views/blog/BlogGeneral.vue';
import BlogSingle from '../views/blog/BlogSingle.vue';

export default [
  {
    path: '/blog',
    name: 'blog',
    component: Blog,
    children: [
      {
        path: '/blog',
        name: 'blog-geral',
        component: BlogGeneral,
      },
      {
        path: '/blog/assunto/:id',
        name: 'blog-single',
        props: true,
        component: BlogSingle,
      },
    ],
  },
];
